import React from "react";
import { Link } from "react-router-dom";
import T from "prop-types";
import { connect } from "react-redux";
import { markRead } from "MODULES/Notifications/actions";

const ItemLink = ({
  markNotificationRead,
  notificationId,
  path,
  id,
  displayText
}) => (
  <span
    onClick={e => {
      e.stopPropagation();
      markNotificationRead(notificationId);
    }}
  >
    <Link to={`/${path}/${id}`}>{displayText}</Link>
  </span>
);

export default connect(undefined, dispatch => ({
  markNotificationRead: noteId => dispatch(markRead(noteId))
}))(ItemLink);

ItemLink.propTypes = {
  markNotificationRead: T.func,
  notificationId: T.number,
  path: T.string,
  id: T.string,
  displayText: T.string
};



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/ItemLink.jsx